/// <reference path="../../../scripts/typings/Nema.Crew.Model.d.ts" />

import service = require("./breeze.entitymanager.service");
import base = require("./base.dataservice");

export function initialize(module: ng.IModule) {
    module.service(CompetenceRequirementCollectionWorkplaceDataService.Id, CompetenceRequirementCollectionWorkplaceDataService);

    CompetenceRequirementCollectionWorkplaceDataService.$inject = ["entityManagerService", "breeze", "$log", "$q"];
}

export class CompetenceRequirementCollectionWorkplaceDataService extends base.BaseDataService<Nema.Crew.Model.CompetenceRequirementCollectionWorkplace> implements ICompetenceRequirementCollectionWorkplaceDataService {

    constructor(entityManagerService: service.EntityManagerService, breeze, $log, $q: ng.IQService) {
        super(entityManagerService, breeze, $log, $q);
    }

    public static Id: string = "competenceRequirementCollectionWorkplaceDataService";

    public get EntityName(): string {
        return "CompetenceRequirementCollectionWorkplace";
    }

    public get EntitiesName(): string {
        return "CompetenceRequirementCollectionWorkplaces";
    }

    /**
     * Override the getAll, since CompetenceRequirementCollection do not 
     * have the Active and SortTag properties.
     */
    public getAll(_active: boolean = true): ng.IPromise<Nema.Crew.Model.CompetenceRequirementCollectionWorkplace[]>{

        var self = this;

        var entityQuery = self.createEntityQuery()
            .using(this.entityManager);

        var promise = entityQuery.execute()
        // ignore remote query results and chain to local query. Discarded the query results ... but items remain in cache
            .then(() => {
                self.entityCollection = entityQuery.using(self.breeze.FetchStrategy.FromLocalCache).executeLocally();
                return <Nema.Crew.Model.CompetenceRequirementCollectionWorkplace[]><any>self.entityCollection;
        });

        return promise;
    }

    public getAllByRequirementSectionId(requirementSectionId: number) {

        var self = this;

        var entityQuery = self.createEntityQuery()
            .where("CompetenceRequirementCollectionId", "==", requirementSectionId)
            .using(this.entityManager);

        var promise = entityQuery.execute()
        // ignore remote query results and chain to local query. Discarded the query results ... but items remain in cache
            .then(() => {
                self.entityCollection = entityQuery.using(self.breeze.FetchStrategy.FromLocalCache).executeLocally();
                return <Nema.Crew.Model.CompetenceRequirementCollectionWorkplace[]><any>self.entityCollection;
        });

        return promise;
    }
}

export interface ICompetenceRequirementCollectionWorkplaceDataService extends base.IDataService<Nema.Crew.Model.CompetenceRequirementCollectionWorkplace> {
    EntityName: string;

    getAllByRequirementSectionId(requirementSectionId: number): ng.IPromise<Nema.Crew.Model.CompetenceRequirementCollectionWorkplace[]>;
} 


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/competencerequirementcollectionworkplaces.dataservice.ts